/* Hello couleur — recap panier dynamique (port maquette 05_cart).
   Calcule la livraison « a partir de » (mode le moins cher pour le poids du
   panier), le total estime, et declenche le bloc jaune d'estimation de date
   (#cart-delivery-estimate via HC_DELIVERY). Donnees lues sur .cart-summary :
   data-subtotal-cents, data-cart-weight. S'appuie sur HC_SHIPPING + HC_DELIVERY. */
(function () {
  function fmt(v) { return v.toFixed(2).replace('.', ',') + ' €'; }

  function run() {
    if (!window.HC_SHIPPING) return false; // pas encore charge → retry
    var summary = document.querySelector('.cart-summary');
    if (!summary) return true;
    // 2026-10-11 : panier sans rien à expédier (carte cadeau seule) -> pas de frais ni de date de livraison.
    if (summary.dataset.requiresShipping === '0') {
      var lb = document.getElementById('summary-shipping-label');
      var sh = document.getElementById('summary-shipping');
      if (lb) lb.innerHTML = 'Livraison';
      if (sh) sh.textContent = 'Aucune, envoi par e-mail';
      var est = document.getElementById('cart-delivery-estimate');
      if (est) est.textContent = '';
      return true;
    }
    var sub = parseInt(summary.dataset.subtotalCents, 10) || 0;
    // total apres remises (cart.total_price) ; fallback sur le sous-total si absent
    var totalBase = parseInt(summary.dataset.totalCents, 10);
    if (isNaN(totalBase)) totalBase = sub;
    var weight = parseInt(summary.dataset.cartWeight, 10) || 0;
    var threshold = (window.HC_SHIPPING.FREE_THRESHOLD || 50) * 100;
    // Pays du visiteur (marchés Shopify) : livraison offerte en France seulement ; à l'étranger, tarifs du pays.
    var pays = summary.dataset.country || (window.Shopify && window.Shopify.country) || 'FR';
    // 2026-10-06 : offerte dès 50 € en point relais Mondial Relay uniquement (particuliers) ; autres modes payants.
    // Compte pro (B2B) : jamais de livraison offerte (pas de point relais pour les pros ; estimation « à partir de » selon le poids).
    var free = summary.dataset.b2b ? false : (pays === 'FR' && sub >= threshold && sub > 0);
    var cheap = window.HC_SHIPPING.cheapest(weight, pays);
    var shipEur = free ? 0 : (cheap ? cheap.price : 0);

    var labelEl = document.getElementById('summary-shipping-label');
    var shipEl = document.getElementById('summary-shipping');
    var totalEl = document.getElementById('summary-total');

    if (free) {
      if (labelEl) labelEl.innerHTML = 'Livraison';
      if (shipEl) shipEl.innerHTML = '<strong style="color:var(--c-nuit-velour);">Offerte en point relais 🎉</strong>';
    } else {
      if (labelEl) labelEl.innerHTML = 'Livraison <span style="color:var(--c-crayon);font-weight:400;">(à partir de)</span>';
      if (shipEl) shipEl.textContent = cheap ? fmt(shipEur) : 'calculée au paiement';
    }
    if (totalEl) totalEl.textContent = fmt(totalBase / 100 + shipEur);

    if (window.HC_DELIVERY) window.HC_DELIVERY.refreshCart(pays !== 'FR' ? null : (free ? (window.HC_SHIPPING.FREE_METHOD || 'mr_relais') : (cheap && cheap.key)));
    return true;
  }

  function boot() {
    if (run()) return;
    var tries = 0;
    var iv = setInterval(function () { tries++; if (run() || tries > 20) clearInterval(iv); }, 50);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
